import enviro from 'enviro';
import idpAuthApiClient from 'hub-http-janus/clients/idpAuthApiClient';
import userInfo from 'hubspotter-http/hubSpotterInfo';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getDraftListingRpc } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingEditorRpc-internal';
const QA_PORTAL_ID = 895418748;
const PROD_PORTAL_ID = 49739354;
const isQa = () => enviro.isQa();
export async function getDraftListing({
  listingId,
  language
}) {
  const chirpClient = createRpcClientV2({
    hubHttpClient: idpAuthApiClient
  });
  const {
    hubspotter: user
  } = await userInfo();
  const userId = Number(user.employeeId) || 0;
  const response = await chirpClient.call(getDraftListingRpc, {
    request: {
      listingId,
      language
    },
    portalId: isQa() ? QA_PORTAL_ID : PROD_PORTAL_ID,
    userId
  });
  return response;
}